import MuiSelect from "@mui/material/Select";
const Select = MuiSelect;
export default Select;
